import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, of, retry } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { getSessionId } from '../../../helpers/storageUtils';
import { UtilsService } from '../../../services/utils.service';
import { TokenService } from '../token.service';

@Injectable({
  providedIn: 'root',
})
export class BankService {
  baseUrl = environment.URL_BANCOS;

  private tokenService = inject(TokenService);
  token = this.tokenService.getToken();
  private http = inject(HttpClient);
  SESSION_ID = getSessionId().toString();
  private utils = inject(UtilsService);

  public getBeneficiaryList(product: string): Observable<unknown> {
    const url = this.baseUrl;
    const params = new HttpParams().set('product', product);

    const headers = this.utils.getHeaders(this.SESSION_ID);

    return this.http.get<unknown>(url, { headers, params }).pipe(
      retry(2),
      catchError((error) => {
        console.error('Failed request for getBeneficiaryList:', error);
        return of(null); // Retornar null en caso de error para permitir que el flujo continúe
      }),
    );
  }
}
